module.exports = __webpack_public_path__ + "static/img/partner-makeblock.3d3f882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-makeblock.png
// module id = 2set
// module chunks = 34